import { OWebPageBase } from "oweb";
import PUserEditComponent from "@/components/pages/oweb/PUserEdit.vue";
import { VueConstructor } from 'vue';

export default class PUserEdit extends OWebPageBase<VueConstructor> {
	getName() {
		return "PUserEdit"
	}

	getRoutes() {
		return [ {
			title: "OO_LANG_USER_INFO_EDIT",
			path: "/me/edit"
		} ]
	}

	requireLogin() {
		return true
	}
	getComponent() {
		return PUserEditComponent;
	}
}